






















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Autocomplete from '../../../../molecules/Autocomplete/Autocomplete.vue';
import { FilledButton } from '@/components/molecules';
import eventBus from '@/utils/eventBus';

interface IOption {
  id: string;
  label: string;
}

@Component({
  components: {
    Autocomplete,
    FilledButton
  }
})
export default class SelectorAndList extends Vue {
  @Prop({ default: () => [] }) readonly value!: IOption[];
  @Prop({ default: () => [] }) readonly options!: IOption[];
  @Prop({ default: '' }) readonly label!: string;
  @Prop({ default: '' }) readonly placeholder!: string;
  @Prop({ default: true }) readonly multipleSelect!: boolean;
  @Prop({ default: false }) readonly disabled?: boolean;
  @Prop({ default: true }) readonly showEmailList?: boolean;
  @Prop({ default: false }) readonly showAddButton?: boolean;

  searchText = '';

  onSearch(search: string) {
    this.searchText = search;
    this.$emit('search', search);
  }

  addItem(selected: IOption) {
    if (!this.multipleSelect) {
      this.removeItem(this.value[0]);
    }

    this.value.push(selected);
    this.dispatchItemSelected(selected);
  }

  removeItem(item: IOption) {
    const idx = this.value.findIndex(val => val.id === item.id);
    if (idx >= 0) {
      this.value.splice(idx, 1);
    }

    this.dispatchItemRemoved(item);
  }

  getLabel(item: any) {
    if (!this.showEmailList) {
      return `${item.name} ${item.lastname}`;
    }
    return item.label;
  }

  //Events
  @Emit('itemSelected')
  dispatchItemSelected(selected: IOption) {
    return selected;
  }

  @Emit('itemRemoved')
  dispatchItemRemoved(item: IOption) {
    return item;
  }

  clearValue() {
    this.searchText = '';
  }

  created() {
    eventBus.$on('clearAutocomplete', this.clearValue);
  }

  destroy() {
    eventBus.$off('clearAutocomplete', this.clearValue);
  }
}
